import Bullhorn24 from '@carbon/icons-react/es/bullhorn/24';
import Document24 from '@carbon/icons-react/es/document/24';
import Roadmap24 from '@carbon/icons-react/es/roadmap/24';
import { Menu as AntMenu } from 'antd';
import styled from 'styled-components';
import { ReactComponent as FormTemplateIconSvg } from 'assets/svgs/form-instance-icon.svg';
import { Loading as LoadingAtom } from 'components/atoms/loading';

export const TemplatesWrapper = styled.div`
  padding-left: var(--spacing-03);
`;

export const Menu = styled(AntMenu)`
  border-right: 0;
  padding: var(--layout-01);
  .ant-menu-item,
  .ant-menu-submenu-title {
    height: var(--height-base);
    line-height: var(--height-base);
    margin-bottom: 0;
    margin-top: 0;
    padding: 0 var(--layout-02);
  }
  .ant-menu-item-selected {
    background: none;
  }
  .ant-menu-item a:hover {
    color: var(--black-100);
  }
  .ant-menu-item-selected a {
    color: var(--black-100);
    font-weight: var(--heading-7-weight);
  }
`;

export const Loading = styled(LoadingAtom)`
  min-width: var(--input-height-default);
`;

export const RoadMap = styled(Roadmap24)`
  fill: var(--green-40);
`;

export const Document = styled(Document24)`
  fill: var(--blue-40);
`;

export const Bullhorn = styled(Bullhorn24)`
  fill: var(--teal-40);
`;

export const FormTemplateIcon = styled(FormTemplateIconSvg)`
  fill: var(--teal-40);
  width: 24px;
  height: 24px;
`;
